import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { baseCandidatesEffects, baseCandidatesReducer } from '../../_store';

@NgModule({
  imports: [
    StoreModule.forFeature('candidates', baseCandidatesReducer.BaseCandidatesReducer),
    EffectsModule.forFeature([baseCandidatesEffects.BaseCandidatesEffects]),
  ],
})
export class BaseCandidatesStoreModule {}
